var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('px-card',{staticClass:"order-graph sales-carousel",attrs:{"title":"Buy / Sell"}},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"buy-chart"},[_c('apexchart',{attrs:{"type":"line","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }